const faqs = [
  {
    id: 1,
    heading: "How does AI Integration work?",
    content: "Our AI solutions integrate seamlessly with your systems, using machine learning and algorithms to enhance efficiency and provide real-time insights.",
  },
  {
    id: 2,
    heading: "What are the benefits of ML?",
    content: "Machine learning analyzes data to uncover patterns and opportunities, improving decision-making, enhancing customer experience, and boosting efficiency.",
  },
  {
    id: 3,
    heading: "Do you offer custom AI solutions?",
    content: "Yes, we tailor AI solutions to your specific needs. Our team works with you to understand your challenges and deliver solutions to meet your goals.",
  },
  {
    id: 4,
    heading: "Is my data secure with AI?",
    content: "We prioritize your data security with robust encryption and advanced security protocols, ensuring your data remains safe and protected.",
  },
  {
    id: 5,
    heading: "What is the cost of AI implementation?",
    content: "AI implementation costs vary based on project scope and system complexity. Typically, the ROI comes quickly from improved productivity and customer engagement.",
  },
];

export default faqs;